import { apiFetch, postJson } from './apiClient';
import {
  ChangePasswordRequest,
  UpdateUserProfileRequest,
  UserProfile,
} from '../types/profile';

const PROFILE_PATH = '/api/v1/profile';

export const profileApi = {
  getProfile: () =>
    apiFetch<UserProfile>(PROFILE_PATH),

  updateProfile: (request: UpdateUserProfileRequest) =>
    apiFetch<void>(PROFILE_PATH, {
      method: 'PUT',
      body: JSON.stringify(request),
    }),

  changePassword: (request: ChangePasswordRequest) =>
    postJson<void>(
      `${PROFILE_PATH}/change-password`,
      request
    ),
};